import apis from '../../service/apis/sendCouponApi'
export const sendCoupon = {
  namespaced: true,
  state: {
    couponDataList: [],
    sendCouponSuccess: false,
    getUsableOrdersByGroupIdSuccess: false,
    haveCheckingOrders: false
  },
  mutations: {
    updatecouponDataList (state, payload) {
      const {data: dataList} = payload.res
      state.getUsableOrdersByGroupIdSuccess = true
      // console.log(dataList)
      // if (dataList.length > 0) {
      state.couponDataList = (dataList||[]).map((dataObj) => {
        dataObj.warning = false
        dataObj.warningTxt = ''
        return dataObj
      })
      // }
      // state.couponDataList = []
    },
    updateCouponDataListFormCompon (state, payload) {
      state.couponDataList = payload.dataList
    },
    sendCouponSuccess (state, payload) {
      state.sendCouponSuccess = payload.res
    },
    updateHaveCheckingOrders (state, payload) {
      if (payload.res.data === 1) {
        state.haveCheckingOrders = true
      }
    },
    initState (state) {
      state.couponDataList = []
      state.sendCouponSuccess = false
      state.getUsableOrdersByGroupIdSuccess = false
      state.haveCheckingOrders = false
    }
  },
  actions: {
    getUsableOrdersByGroupId ({ commit }, params) {
      apis.getUsableOrdersByGroupId(params).then(res => {
        commit('updatecouponDataList', {res})
      })
    },
    sendCoupon ({commit}, params) {
      apis.sendCoupon(params).then(res => {
        commit('sendCouponSuccess', {res})
      })
    },
    ifHaveCheckingOrders ({ commit }, params) {
      apis.ifHaveCheckingOrders(params).then(res => {
        commit('updateHaveCheckingOrders', {res})
      })
    }
  }
}
